import * as React from 'react';
import { memo, useState } from 'react';
import Dump from "../components/dump.tsx";
import { getEnv } from "../helpers/env.ts";
import type { AssetData } from "../mediaLibrary/asset.interface.ts";
import type { ProductData } from "../rest.interface";
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Thumbs } from 'swiper/modules';
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

type Props = {
	artwork: ProductData,
}

function RenderArtwork({artwork}: Props) {
	const [thumbsSwiper, setThumbsSwiper] = useState(null);

	const [lightbox, setLightbox] = useState<{open: boolean, index: number}>({open: false, index: 0});
	const [lightboxOpen, setLightboxOpen] = useState<boolean>(false);

	return (<>
		{artwork &&
			<section className="section flex justify-center h-full">
				<div className="flex flex-wrap flex-grow w-full max-w-screen-2xl text-left items-stretch px-8 md:px-20 xl:px-40 -mx-8">
					<div className="px-8 w-full lg:w-2/5 mb-12">
						<div className="h-full">
							<h4 className="uppercase my-12">{artwork.category.name}</h4>

							<div className="mb-12">
								<h3 className="font-sans tracking-normal">{artwork.name}</h3>
								{artwork.type && <p className="text-grey-500 mb-0 text-xl">{artwork.type}</p>}
								{artwork.width && artwork.height && <p className="text-grey-500 mb-0 text-xl">{artwork.height} x {artwork.width} cm</p>}
							</div>

							<div className="mb-12" dangerouslySetInnerHTML={{__html: artwork.description}}/>

							{artwork.available && artwork.category.showEnquire && <a href="/contact" className="button outlined !text-black">PLEASE ENQUIRE</a>}

							<a href="#" className="block mt-8 text-sm text-grey-500" onClick={() => {
								setLightbox({ index: 0, open: true });
							}}>Click image to expand</a>
						</div>
					</div>
					<div className="px-0 lg:px-8 w-full lg:w-3/5">
						<div className="h-full bg-grey-100 overflow-hidden p-12">
							{artwork && Array.isArray(artwork.gallery) && <>
								<Swiper
									className="swiper text-center"
									modules={[Navigation, Pagination, Autoplay, Thumbs]}
									speed={500}
									loop={false}
									navigation={artwork.gallery.length > 1}
									autoplay={{ delay: 4000, disableOnInteraction: true}}
									pagination={false}
									thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
								>
									{artwork.gallery.map((asset: AssetData, index) => {
										return (
											<SwiperSlide className="swiper-slide" key={'slide' + index}>
												<img
													src={getEnv('PUBLIC_ASSET_HOST') + asset.linkView}
													alt={asset.description}
													width={asset.width}
													height={asset.height}
													className="inline-block cursor-zoom-in"
													onClick={() => {
														setLightbox({ index: index, open: true});
													}}
												/>
											</SwiperSlide>
										);
									})}
								</Swiper>

								{artwork.gallery.length > 1 && <Swiper
									onSwiper={setThumbsSwiper}
									spaceBetween={10}
									slidesPerView={9}
									watchSlidesProgress={true}
									wrapperClass="justify-center"
									modules={[Navigation, Thumbs]}
									className="mt-12"
								>
									{artwork && Array.isArray(artwork.gallery) && artwork.gallery.map((asset: AssetData, index) => {
										return (
											<SwiperSlide className="swiper-slide text-center" key={'slideThumb' + index}>
												<img src={asset.linkThumb} alt={asset.description} width="100" height="100" className="inline-block"/>
											</SwiperSlide>
										);
									})}
								</Swiper>}

								{artwork.gallery.length > 0 && <Lightbox
									open={lightbox.open}
									index={lightbox.index}
									close={() => setLightbox({...lightbox, open: false})}
									plugins={[Zoom]}
									render={{
										buttonPrev: artwork.gallery.length <= 1 ? () => null : undefined,
										buttonNext: artwork.gallery.length <= 1 ? () => null : undefined,
									}}
									slides={
										artwork.gallery.map((asset: AssetData, index) => {
											return {
												src: getEnv('PUBLIC_ASSET_HOST') + asset.linkView,
												alt: asset.description,
												width: asset.width,
												height: asset.height
											}
										})
									}
								/>}
							</>}
						</div>
					</div>
					<Dump value={lightbox}/>
				</div>
			</section>
		}
	</>);
}

export default memo(RenderArtwork);
